export default "__VITE_ASSET__ObgFGH_f__"